import { Crown, Flame, Zap, Lock } from "lucide-react";

const TOTAL_CAP = 100;

// Scarcity-tiered Founder Pass badge driven by live claimed count.
export function FounderBadge({ claimedCount = 0 }) {
  const remaining = Math.max(0, TOTAL_CAP - claimedCount);

  let Icon = Crown;
  let label = "Founding Member Tier";
  let sub = "Strictly capped at the first 100 members • $99/yr for life";
  let tone = "spark-gradient text-white";

  if (claimedCount >= 25 && claimedCount < 75) {
    Icon = Flame;
    label = "High Demand";
    sub = `Over ${Math.floor(claimedCount / 5) * 5} spots claimed • Capped at 100`;
    tone = "spark-gradient text-white";
  } else if (claimedCount >= 75 && remaining > 0) {
    Icon = Zap;
    label = "Final Spots Remaining";
    sub = `Only ${remaining} of ${TOTAL_CAP} founding passes left`;
    tone = "bg-[#F59E0B] text-[#0F172A]";
  } else if (remaining === 0) {
    Icon = Lock;
    label = "Founding Tier Closed";
    sub = `100 of ${TOTAL_CAP} passes claimed • Standard annual rate applies`;
    tone = "bg-[#262D38] text-slate-300 border border-white/10";
  }

  return (
    <div data-testid="founder-badge">
      <span className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${tone}`}>
        <Icon className="w-3.5 h-3.5" /> {label}
      </span>
      <p className="mt-2 text-xs text-slate-400" data-testid="founder-badge-sub">{sub}</p>
    </div>
  );
}
